import { TrafficLightOutlineIcon } from './TrafficLightOutlineIcon';

/**
 * author: Google
 * id 912B0C1C-8E8A-4AA4-9166-C1BCCC85BDF9
 * name traffic-light-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/traffic-light-outline.svg
 * tags
 * - Transportation + Road 
 */
export const TrafficSignalOutlineIcon = TrafficLightOutlineIcon;
export default TrafficSignalOutlineIcon